import React from "react";
import {gql, useQuery} from "@apollo/client";
import {BizMenuLayout} from "../../shares/bizMenuLayout/BizMenuLayout";
import {BizTitle} from "../../shares/bizTitle/BizTitle";
import {Query} from "../../../graphql/types";
import {BizScrollTop} from "../../shares/bizScrollTop/BizScrollTop";
import { EdutechKoreaFairCompanyData } from "./EdutechKoreaFairCompanyData/EdutechKoreaFairCompanyData";

export const EdutechKoreaFairCompanyList = (props: {
    year: number
}) => {
    const {data} = useQuery<Query>(gqlData, {
        variables: {
            year: props.year
        }
    });

    const edutechKoreaFairYear = data?.edutechKoreaFairYear;
    const edutechKoreaFairCompany = data?.edutechKoreaFairCompany;

    return (
        <BizScrollTop>
            {data &&
            <BizMenuLayout
                title={"에듀테크코리아페어"}
                routerPrefix={'/edutechkoreafair'}
                activatedRouterSuffix={`/list/${props.year}`}
                data={
                    edutechKoreaFairYear!.map((value: any) => {
                        return {title: value.year.toString(), routerSuffix: `/list/${value.year}`}
                    })
                }>
                <BizTitle>{props.year}</BizTitle>

                <EdutechKoreaFairCompanyData
                    companyList={edutechKoreaFairCompany!}/>
                    
                <div style={{height: 30}}/>
            </BizMenuLayout>
            }

        </BizScrollTop>
    )
}

const gqlData = gql`
    query EdutechKoreaFair($year: Int!) {
        edutechKoreaFairYear {
            year
        }
        edutechKoreaFairCompany(year: $year) {
            id
            year
            companyData
        }
    }
`;
